import Structor from "../util/structor"

export default class DateAnnotationCourseCustomSingleAttributes extends Structor {
  defineStruct() {
    this.field("title")
    this.field("description", "<p></p>")
    this.field("dateString")
    this.field("isOff")
    this.field("showAnnotation", false)
  }
}
